import { render, staticRenderFns } from "./GroupSessionAttendanceNotification.vue?vue&type=template&id=6bb99ba0&scoped=true&"
import script from "./GroupSessionAttendanceNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionAttendanceNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb99ba0",
  null
  
)

export default component.exports